<template>
    <div>
        <div class="menu" ref="menu">
            <Menu :bus="bus"/>
        </div>

        <div class="contacts">
            <div class="container">
              <div class="row main">
                <div
                  class="contact__container pt-5 pb-5 col-lg-5 d-flex flex-column justify-content-center"
                >
                  <Title astitle="true" v-bind:title="$t('home.contact.title')"/>
                </div>
                <div class="form__container pt-5 pb-5 col-lg-7">
                  <h1 v-html="$t('home.contact.form.title')"></h1>
                  <MainForm class="d-flex text-center mt-5 justify-content-center footer__form"/>
                  <div
                    class="mt-4 contact__container_div d-flex flex-column text-center justify-content-center"
                  >
                    <div>
                      <div class="row contact__locations">
                        <div class="col-sm-4 d-flex flex-column text-center mt-4">
                          <p class="contact__locations_icon">
                            <a href="tel:00390599120411">
                              <img src="@/assets/img/phone.svg">
                            </a>
                          </p>
                          <p>
                            <a href="tel:00390599120411">+39 059.9120411</a>
                          </p>
                        </div>
                        <div class="col-sm-4 d-flex flex-column text-center mt-4">
                          <p class="contact__locations_icon">
                            <a href="mailto:info@weg.it">
                              <img src="@/assets/img/email.svg">
                            </a>
                          </p>
                          <p>
                            <a href="mailto:info@weg.it">info@weg.it</a>
                          </p>
                        </div>
                        <div class="col-sm-4 d-flex flex-column text-center mt-4">
                          <p class="contact__locations_icon">
                            <a href="https://goo.gl/maps/PZBH8VahViRK5sEa9">
                              <img src="@/assets/img/pin.svg">
                            </a>
                          </p>
                          <p>
                            <a href="https://goo.gl/maps/PZBH8VahViRK5sEa9">
                              Via Campania, 3
                              <br>41012 Carpi (Modena) Italy
                            </a>
                          </p>
                        </div>

                        <p
                          class="footer__copy"
                        >Weg srl - P.Iva e cod. Fisc. 02485070359 - Codice univoco: subm70n</p>
                        <div class="col-sm-12 mt-5 contact__member">
                          <p>
                            Member of
                            <a href="http://www.wegfashiongroup.com/" target="_blank" rel="noopener">
                              <img src="@/assets/img/wfg.png">
                            </a>
                          </p>
                        </div>
                      </div>

                      <p>
                        <a
                          :href="'//www.iubenda.com/privacy-policy/' + $t('iubendaid')"
                          target="_blank" rel="noopener"
                          class="iubenda-nostyle no-brand"
                          title="Privacy Policy"
                        >Privacy policy</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import Vue from "vue";
import Contenuto from "@/components/Contenuto";
import Menu from "@/components/Menu";
import MainForm from "@/components/form/MainForm";
import Title from "@/components/Title";
import Footer from "@/components/Footer";

export default {
    name: 'research',
    components: {
        Title,
        Menu,
        Contenuto,
        MainForm,
        Footer
    },
    data() {
        return {
            bus: new Vue()
        }
    },
    mounted() {
      this.$nextTick(() => {
        (function(w, d) {
          var loader = function() {
            var s = d.createElement("script"),
              tag = d.getElementsByTagName("script")[0];
            s.src = "//cdn.iubenda.com/iubenda.js";
            tag.parentNode.insertBefore(s, tag);
          };
          if (w.addEventListener) {
            w.addEventListener("load", loader, false);
          } else if (w.attachEvent) {
            w.attachEvent("onload", loader);
          } else {
            w.onload = loader;
          }
        })(window, document);
      })
    }
}
</script>

<style scoped lang="scss">
    .main {
        padding-top: 80px;
        @include media-breakpoint-up(md) {
            padding-top: 220px;
        }
    }


.contacts {
  height: 100%;
  position: relative;
  &:before {
    content: "";
    position: absolute;
    z-index: 0;
    background: $red url("~@/assets/img/Contatti.jpg") no-repeat center center /
      cover;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: none;
    @include media-breakpoint-up(lg) {
      width: 40%;
      display: block;
    }
    @media (max-height: 800px) {
      display: none !important;
    }
  }
  &:after {
    content: "";
    position: absolute;
    z-index: -1;
    background: black;
    width: 100%;
    height: 100%;
    right: 0;
    top: 0;
    width: 100%;
  }
  > div {
    position: relative;
    z-index: 2;
  }

  h1 {
    color: white;
  }
}
.contact__container {
  &,
  a {
    color: $white;
  }
  @media (max-height: 800px) {
    display: none !important; 
  }
}

.form__container {
  @media (max-height: 800px) {
    width: 100% !important;
    max-width: 100%;
    flex: 100% !important;
  }
}

.contact__container_div {
  a {
    color: white;
  }
}
.contact__member {
  color: white;
  text-align: center;
  img {
    margin-left: 10px;
    margin-top: -8px;
    vertical-align: middle;
  }
  @media(max-height: 900px) {
    margin-top: 10px;
  }
}
.contact__locations {
  margin-bottom: 20px;
  a {
    font-size: 14px;
    display: inline-block;
  }
  p {
    margin-bottom: 0;
  }
  @media(max-height: 900px) {
    margin-bottom: 5px;
  }
}
.contact__locations_icon {
  height: 48px;
  margin-bottom: 7px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media(max-height: 900px) {
    height: 44px;
  }
}
.form__container > h1 {
  @include media-breakpoint-down(sm) {
    font-size: 22px;
  }
}
.form__container /deep/ .mainform {
  @include media-breakpoint-up(md) {
    width: 100%;
  }
}
.footer__copy {
  color: #9c9e9f;
  font-size: 13px;
  margin-top: 40px;
  text-align: center;
  width: 100%;
  @media(max-height: 900px) {
    margin-top: 10px;
  }
}

.footer__form /deep/ {
  .message,
  textarea,
  a,
  input {
    color: white;
  }
  a {
    text-decoration: underline;
  }
  textarea,
  input:not([type="submit"]) {
    border-bottom-color: white;
  }
  input[type="checkbox"] {
    flex-shrink: 0;
  }
  textarea {
    height: 35px;
  }
  form {
    display: flex;
    flex-wrap: wrap;
  }
  @include media-breakpoint-up(sm) {
    .form-group:nth-last-child(-n + 2) {
      margin-bottom: 0;
    }
    form > div {
      width: calc(50% - 20px);
    }
    form > div:nth-child(odd) {
      margin-right: 20px;
    }
  }
}

.iubenda-nostyle {
  font-size: 13px;
}
</style>